
  var _styles = {
  "flex": {
    "display": "flex"
  },
  "flex-item": {
    "flex": 1
  },
  "negative-margin": {
    "marginTop": 0,
    "marginRight": "-0.32rem",
    "marginBottom": 0,
    "marginLeft": "-0.32rem"
  },
  "title": {
    "position": "relative",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": "0.33333rem",
    "paddingLeft": "0.26667rem",
    "lineHeight": "0.61333rem",
    "fontSize": "0.42667rem",
    "color": "rgb(255,255,255)",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "title-after": {
    "position": "relative",
    "left": "-0.2rem",
    "width": "0.08rem",
    "height": "0.4rem"
  },
  "flex-item-label": {
    "fontSize": "0.42667rem",
    "color": "rgb(255,255,255)",
    "fontWeight": "500"
  },
  "flex-item-switch": {
    "fontSize": "0.34667rem",
    "textAlign": "right",
    "color": "rgb(255,255,255)"
  },
  "flight-special-ticket-container": {
    "position": "relative",
    "width": "100%",
    "fontSize": 0
  },
  "special": {
    "width": "100%",
    "padding": "0.33333rem",
    "fontSize": "0.4rem",
    "background": "#165593"
  },
  "special_location": {
    "position": "relative",
    "height": "1.06667rem"
  },
  "special_location-city": {
    "display": "inline-block",
    "paddingTop": 0,
    "paddingRight": "0.86667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.86667rem",
    "height": "1.06667rem",
    "lineHeight": "1.06667rem",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "backgroundSize": "0.4rem",
    "backgroundPosition": "0.2rem center"
  },
  "special_location_cities": {
    "position": "absolute",
    "left": 0,
    "top": "1.06667rem",
    "zIndex": 99,
    "width": "100%",
    "maxHeight": "6.66667rem",
    "background": "#c4d4de",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(247,247,247)",
    "borderRadius": "0.10667rem",
    "boxShadow": "0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04)",
    "opacity": 0.95,
    "overflowX": "hidden",
    "overflowY": "auto"
  },
  "special_location_cities_city": {
    "float": "none",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "height": "1.17333rem",
    "lineHeight": "1.17333rem",
    "fontSize": "0.37333rem",
    "color": "rgb(102,102,102)",
    "borderBottomWidth": ".04px",
    "borderBottomStyle": "solid",
    "borderBottomColor": "rgb(229,229,229)",
    "listStyle": "none",
    "borderBottomWidthity:last-child": "none",
    "borderBottomColority:last-child": null
  },
  "special_tab": {
    "marginTop": 0,
    "marginRight": 0,
    "marginBottom": "0.13333rem",
    "marginLeft": 0,
    "borderRadius": "0.08rem",
    "boxShadow": "0 0 0 0 rgba(216,216,216,.5)",
    "background": "#fff",
    "overflow": "hidden"
  },
  "special_tab-list": {
    "float": "left",
    "width": "50%",
    "height": "0.96rem",
    "lineHeight": "0.96rem",
    "fontSize": "0.37333rem",
    "fontFamily": "PingFangSC-Medium",
    "textAlign": "center"
  },
  "special_tab-list-content": {
    "display": "inline-block",
    "width": "1.22667rem"
  },
  "special_tab-list-contentactive": {
    "height": "0.96rem",
    "color": "rgb(253,130,49)",
    "borderBottomWidth": "0.05333rem",
    "borderBottomStyle": "solid",
    "borderBottomColor": "rgb(253,130,49)"
  },
  "airline": {
    "overflow": "hidden"
  },
  "wrapper_list": {
    "marginTop": 0,
    "marginRight": 0,
    "marginBottom": "0.13333rem",
    "marginLeft": 0,
    "paddingTop": "0.29333rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.29333rem",
    "paddingLeft": "0.32rem",
    "width": "100%",
    "height": "1.69333rem",
    "borderRadius": "0.10667rem",
    "boxShadow": "0 0 0 0 rgba(216,216,216,.5)",
    "background": "#fff",
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginTopt:last-child": 0,
    "marginRightt:last-child": 0,
    "marginBottomt:last-child": 0,
    "marginLeftt:last-child": 0
  },
  "wrapper_list_corner-label": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "position": "absolute",
    "borderBottomRightRadius": "0.18667rem",
    "paddingTop": 0,
    "paddingRight": "0.18667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.18667rem",
    "left": 0,
    "top": 0
  },
  "wrapper_list_corner-img": {
    "position": "absolute",
    "top": 0,
    "left": "0.4rem",
    "height": "0.42667rem"
  },
  "wrapper_listnothing": {
    "lineHeight": "1.2rem",
    "textAlign": "center"
  },
  "wrapper_list_info": {
    "float": "left",
    "width": "4.8rem"
  },
  "wrapper_list_infomove-down": {
    "position": "relative",
    "top": "0.13333rem"
  },
  "wrapper_list_info_line": {
    "height": "0.66667rem",
    "fontSize": "0.48rem",
    "color": "rgb(51,51,51)",
    "letterSpacing": "-0.44px",
    "overflow": "hidden"
  },
  "wrapper_list_info_line_site": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "100%"
  },
  "wrapper_list_info_line_site>arrow": {
    "position": "relative",
    "bottom": "0.13333rem",
    "display": "inline-block",
    "width": "0.34667rem",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(153,153,153)",
    "borderLeftWidth": "none",
    "borderLeftColor": null,
    "borderRightWidth": "none",
    "borderRightColor": null,
    "marginTop": "0.2rem",
    "marginRight": "0.13333rem",
    "marginBottom": 0,
    "marginLeft": "0.13333rem",
    "contentarrow::before": 0,
    "positionarrow::before": "absolute",
    "toparrow::before": "-0.10667rem",
    "rightarrow::before": "0.04rem",
    "widtharrow::before": "0.02667rem",
    "heightarrow::before": "0.10667rem",
    "backgroundarrow::before": "#999",
    "transformarrow::before": "rotate(130deg)",
    "contentarrow::after": 0,
    "positionarrow::after": "absolute",
    "toparrow::after": "0.04rem",
    "leftarrow::after": "0.01333rem",
    "widtharrow::after": "0.02667rem",
    "heightarrow::after": "0.10667rem",
    "backgroundarrow::after": "#999",
    "transformarrow::after": "rotate(130deg)"
  },
  "wrapper_list_info_line_site>arrowoneway": {
    "borderBottomWidth": "none",
    "borderBottomColor": null,
    "heightoneway::after": 0
  },
  "wrapper_list_info_line_site>arrowtwoway": {
    "height": "0.10667rem"
  },
  "wrapper_list_info_line_visa": {
    "float": "left",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem"
  },
  "wrapper_list_info_line_visa>span": {
    "display": "inline-block",
    "position": "relative",
    "bottom": "0.05333rem",
    "fontSize": "0.29333rem",
    "color": "rgb(253,130,49)",
    "borderWidth": "0.02667rem",
    "borderStyle": "solid",
    "borderColor": "rgb(253,130,49)",
    "borderRadius": "0.05333rem"
  },
  "wrapper_list_info_date": {
    "height": "0.53333rem",
    "lineHeight": "0.53333rem",
    "color": "rgb(153,153,153)",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "wrapper_list_info_date-go": {
    "fontSize": "0.29333rem"
  },
  "wrapper_list_info_date-back": {
    "fontSize": "0.29333rem",
    "marginLeft": "0.13333rem"
  },
  "wrapper_list_price": {
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": 0,
    "lineHeight": "1.2rem",
    "fontSize": "0.64rem",
    "width": "2.66667rem",
    "textAlign": "right",
    "color": "rgb(255,98,48)",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "flex-end"
  },
  "wrapper_list_price-single": {
    "width": "2.66667rem"
  },
  "wrapper_list_pricemove-down": {
    "position": "relative",
    "top": "0.13333rem"
  },
  "wrapper_list_price-mini": {
    "fontSize": "0.53333rem"
  },
  "wrapper_list_price_price-symbol": {
    "fontSize": "0.32rem"
  },
  "wrapper_list_price_price-large": {
    "fontSize": "0.64rem"
  },
  "wrapper_list_btn": {
    "flex": 1,
    "height": "100%"
  },
  "wrapper_list_btnmove-down": {
    "position": "relative",
    "top": "0.13333rem"
  },
  "wrapper_list_btn_btn-text": {
    "display": "inline-block",
    "marginTop": "0.2rem",
    "marginRight": 0,
    "marginBottom": 0,
    "marginLeft": 0,
    "width": "1.22667rem",
    "height": "0.8rem",
    "lineHeight": "0.8rem",
    "textAlign": "center",
    "fontSize": "0.34667rem",
    "color": "rgb(255,255,255)",
    "borderRadius": "0.05333rem",
    "background": "#ff6230"
  },
  "wrapper-ui-2": {
    "width": "100%",
    "justifyContent": "space-between",
    "flexWrap": "wrap",
    "flexDirection": "row",
    "overflow": "hidden"
  },
  "wrapper-ui-2_list": {
    "flex": "0 1 48%",
    "marginTop": "0.24rem",
    "marginRight": 0,
    "marginBottom": 0,
    "marginLeft": 0,
    "textAlign": "left",
    "position": "relative",
    "marginTopt:first-child": 0,
    "marginRightt:first-child": 0,
    "marginBottomt:first-child": 0,
    "marginLeftt:first-child": 0,
    "marginTopt:nth-child(2)": 0,
    "marginRightt:nth-child(2)": 0,
    "marginBottomt:nth-child(2)": 0,
    "marginLeftt:nth-child(2)": 0
  },
  "wrapper-ui-2_list_corner-img": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "height": "0.34667rem"
  },
  "wrapper-ui-2_list_corner-label": {
    "fontSize": "0.48rem",
    "transform": "scale(0.5)",
    "paddingTop": 0,
    "paddingRight": "0.21333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.21333rem",
    "transformOrigin": "0 0",
    "position": "absolute",
    "top": 0,
    "left": 0
  },
  "wrapper-ui-2_listnothing": {
    "flex": 1,
    "lineHeight": "1.2rem",
    "textAlign": "center",
    "borderRadius": "0.10667rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "wrapper-ui-2_list_line": {
    "paddingTop": "0.29333rem",
    "paddingRight": "0.26667rem",
    "paddingBottom": "0.14667rem",
    "paddingLeft": "0.26667rem",
    "height": "1.38667rem",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": "contain",
    "backgroundColor": "rgb(252,158,46)",
    "backgroundPosition": "0 bottom"
  },
  "wrapper-ui-2_list_line_line-item": {
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "wrapper-ui-2_list_line_site": {
    "flex": 1,
    "height": "0.48rem",
    "color": "rgb(255,255,255)",
    "fontSize": "0.4rem",
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap"
  },
  "wrapper-ui-2_list_line_siteback": {
    "textAlign": "right"
  },
  "wrapper-ui-2_list_line_arrow": {
    "flex": "0 1 0.50667rem",
    "height": "0.12rem",
    "backgroundPosition": "center"
  },
  "wrapper-ui-2_list_line_arrowrefund": {
    "height": "0.24rem",
    "backgroundPosition": "center"
  },
  "wrapper-ui-2_list_line_date": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "paddingTop": "0.16rem",
    "paddingRight": 0,
    "paddingBottom": 0,
    "paddingLeft": 0,
    "color": "rgb(255,255,255)"
  },
  "wrapper-ui-2_list_line_date_date-go": {
    "fontSize": "0.25333rem"
  },
  "wrapper-ui-2_list_line_date_date-back": {
    "fontSize": "0.25333rem"
  },
  "wrapper-ui-2_list_price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "flex-start",
    "paddingTop": "0.2rem",
    "paddingRight": "0.26667rem",
    "paddingBottom": "0.2rem",
    "paddingLeft": "0.26667rem",
    "height": "0.93333rem",
    "fontSize": "0.24rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "wrapper-ui-2_list_price_price-symbol": {
    "color": "rgb(255,108,0)",
    "fontSize": "0.26667rem"
  },
  "wrapper-ui-2_list_price_large": {
    "fontSize": "0.50667rem",
    "color": "rgb(255,108,0)",
    "marginRight": "0.06667rem",
    "marginLeft": "0.01333rem"
  },
  "wrapper-ui-3": {
    "width": "100%"
  },
  "wrapper-ui-3-list": {
    "width": "100%",
    "height": "2.72rem",
    "paddingTop": "0.26667rem",
    "paddingRight": "0.26667rem",
    "paddingBottom": "0.26667rem",
    "paddingLeft": "3.86667rem",
    "marginBottom": "0.26667rem",
    "position": "relative",
    "background": "#000"
  },
  "wrapper-ui-3-corner-img": {
    "position": "absolute",
    "top": "0.26667rem",
    "left": "0.26667rem",
    "zIndex": 10
  },
  "wrapper-ui-3-corner-label-container": {
    "position": "absolute",
    "top": "0.26667rem",
    "left": "0.26667rem"
  },
  "wrapper-ui-3-corner-label": {
    "fontSize": "0.24rem",
    "zIndex": 10,
    "paddingTop": 0,
    "paddingRight": "0.10667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.10667rem"
  },
  "wrapper-ui-3-item-img": {
    "position": "absolute",
    "top": "0.26667rem",
    "left": "0.26667rem",
    "width": "3.2rem",
    "height": "2.18667rem"
  },
  "wrapper-ui-3-city": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.4rem",
    "color": "rgb(51,51,51)",
    "marginBottom": "0.04rem"
  },
  "wrapper-ui-3-describe": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "height": "0.45333rem"
  },
  "wrapper-ui-3-label": {
    "height": "0.45333rem",
    "marginBottom": "0.04rem"
  },
  "wrapper-ui-3-label-img": {
    "height": "0.42667rem"
  },
  "wrapper-ui-3-label-word": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.29333rem",
    "borderRadius": "0.05333rem",
    "paddingTop": 0,
    "paddingRight": "0.13333rem",
    "paddingBottom": 0,
    "paddingLeft": "0.13333rem"
  },
  "wrapper-ui-3-price": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.53333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "flex-start"
  },
  "wrapper-ui-3-price-large": {
    "fontSize": "0.53333rem"
  },
  "wrapper-ui-3-price-rmb": {
    "fontSize": "0.32rem",
    "marginRight": "0.06667rem"
  },
  "wrapper-ui-3-price-xie-line": {
    "marginLeft": "0.06667rem"
  },
  "wrapper-ui-3-button": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(255,255,255)",
    "textAlign": "center",
    "borderRadius": "0.13333rem",
    "position": "absolute",
    "right": "0.26667rem",
    "bottom": "0.26667rem",
    "paddingTop": "0.17333rem",
    "paddingRight": "0.22667rem",
    "paddingBottom": "0.17333rem",
    "paddingLeft": "0.22667rem"
  }
};



  module.exports = _styles;
  